// Google Map of the Dealer and MapFiom articles. `params` is the JSON the component
// serialises: { label, key, elmId, mapId, address, dealers }.

window.initmap = async (params) => {
    const { label, key, elmId, mapId, address, dealers } = JSON.parse(params);

    // Google's dynamic library loader, as published in the Maps JavaScript API docs
    ((g) => {
        var h, a, k, p = 'The Google Maps JavaScript API', c = 'google', l = 'importLibrary', q = '__ib__', m = document, b = window;
        b = b[c] || (b[c] = {});
        var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => {
            await (a = m.createElement('script'));
            e.set('libraries', [...r] + '');
            for (k in g) e.set(k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()), g[k]);
            e.set('callback', c + '.maps.' + q);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = f;
            a.onerror = () => h = n(Error(p + ' could not load.'));
            a.nonce = m.querySelector('script[nonce]')?.nonce || '';
            m.head.append(a);
        }));
        d[l] ? console.warn(p + ' only loads once. Ignoring:', g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
    })({
        key: key,
        v: 'weekly'
    });

    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const { Geocoder } = await google.maps.importLibrary('geocoding');

    const bounds = new google.maps.LatLngBounds();
    const geocoder = new Geocoder();
    geocoder.geocode({ address: `${address},NL` }, (results) => {
        if (!results || results.length === 0) {
            return;
        }
        const position = results[0].geometry.location;

        const map = new Map(document.getElementById('map-' + elmId), {
            zoom: dealers ? 8 : 17,
            center: dealers ? new google.maps.LatLng(52.092876, 5.104480) : position,
            mapId: mapId,
            disableDefaultUI: true
        });

        if (dealers) {
            dealers.forEach(dealer => {
                const icon = document.createElement('img');
                icon.src = `/images/marker-small-${label}.png`;
                icon.style.width = '24px';

                bounds.extend({ lat: Number(dealer.latitude), lng: Number(dealer.longitude) });

                new AdvancedMarkerElement({
                    map: map,
                    position: { lat: Number(dealer.latitude), lng: Number(dealer.longitude) },
                    title: '',
                    content: icon
                });
            });
            map.fitBounds(bounds);
        } else {
            const icon = document.createElement('img');
            icon.src = `/images/marker-${label}.png`;
            icon.style.width = '5vh';

            new AdvancedMarkerElement({
                map: map,
                position: position,
                title: label,
                content: icon
            });
        }
    });

    return true;
};
